import { useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import { Card } from '@arionbanki/arionui';
import { RiskProfile } from 'types';
import donat_a from 'img/donat_a.svg';
import donat_b from 'img/donat_b.svg';
import donat_c from 'img/donat_c.svg';
import donat_d from 'img/donat_d.svg';
import donat_e from 'img/donat_e.svg';

const IMAGES: { [key: string]: string } = {
	A: donat_a,
	B: donat_b,
	C: donat_c,
	D: donat_d,
	E: donat_e
};

type RiskqResultsProfileBoxProps = Readonly<
	RiskProfile & {
		disabled?: boolean;
		hendleClick: Function;
		isChecked: boolean;
		label: string;
		withImage: boolean;
	}
>;

export function RiskqResultsProfileBox(props: RiskqResultsProfileBoxProps) {
	const { disabled, hendleClick, id, isChecked, label, name = '-A', withImage } = props;
	const onClick = useCallback(() => hendleClick(id), [id, hendleClick]);
	const content = (
		<>
			{label && <div className="riskq-results-label">{label}</div>}
			<h5>{name}</h5>
			<ReactMarkdown>{props.description}</ReactMarkdown>
		</>
	);
	return (
		<Card checked={isChecked} className="py-3 riskq-results" disabled={disabled} onClick={onClick}>
			{withImage ? (
				<div className="row">
					<div className="col-2 pt-2">
						<img alt="" src={IMAGES[name.slice(-1)]} />
					</div>
					<div className="col-10">{content}</div>
				</div>
			) : (
				content
			)}
		</Card>
	);
}
